(function(){
  var LIVE='https://odoo.phonexchange.com.au/pex/buyback/prices';
  var SNAP='https://cdn.shopify.com/s/files/1/0992/3162/9619/files/pe-buyback-v2.json?v=1785993805';
  var NL=String.fromCharCode(10);
  var QT=String.fromCharCode(34);

  /* 2026-09-11
     - Premium now states the battery requirement (above 95%).
     - Used is quoted as a ceiling: the A-grade price with an "Up to" prefix,
       because the final grade (A to D) is set on inspection.
     - Two faults now carry a fixed, automatic deduction instead of
       "assessed on inspection": cracked back glass (-A$150) and battery health
       below 81% (-A$80). Everything else is still assessed by hand.
       The amounts live on the checkboxes in sections/sell-page.liquid as
       data-deduct, in WHOLE DOLLARS - the same unit the price feed uses - so
       they can be changed without touching this file. */
  var TIERS=[
    {g:'N',name:'New',desc:'Sealed or never used'},
    {g:'S',name:'Premium',desc:'Barely used, no visible marks. Battery health above 95%.'},
    {g:'A',name:'Used',desc:'Will be graded from A to D based on aesthetics.',upto:true,
     note:'Offered price is subject to change based on wear and tear.'}
  ];
  var SORD={'16GB':1,'32GB':2,'64GB':3,'128GB':4,'256GB':5,'512GB':6,'1TB':7,'2TB':8};
  var CATNAME={iphone:'iPhone',samsung:'Samsung',tablet:'iPad / Tablet',other:'Other'};

  var $=function(id){return document.getElementById(id);};
  var DATA=null, LIST=[], cat='iphone', cur=null, curStorage=null, curTier='A', hi=-1;

  var ORD={'2ND':'2nd','3RD':'3rd','4TH':'4th','5TH':'5th','6TH':'6th','7TH':'7th','8TH':'8th','9TH':'9th','10TH':'10th','11TH':'11th','12TH':'12th','13TH':'13th'};
  var RE_YEAR=/^(19|20)[0-9][0-9]$/, RE_CHIP=/^M[0-9]$/, RE_NUME=/^[0-9]+E$/, RE_NUM=/^[0-9]/, RE_TRI=/^[0-9][0-9][0-9]$/;

  function pretty(code){
    var t=code.split('_'), out=[], paren=[];
    for(var i=0;i<t.length;i++){
      var w=t[i];
      if(w==='IPHONE'){out.push('iPhone');continue;}
      if(w==='IPAD'){out.push('iPad');continue;}
      if(w==='GALAXY'){out.push('Galaxy');continue;}
      if(w==='PIXEL'){out.push('Google Pixel');continue;}
      if(w==='NOKIA'){out.push('Nokia');continue;}
      if(w==='NOTHING'){out.push('Nothing');continue;}
      if(w==='PLUS'){ if(out.length){out[out.length-1]=out[out.length-1]+'+';} continue; }
      if(w==='INCH'){ if(out.length){var p=out.pop();out.push(fmtInch(p));} continue; }
      if(ORD[w]){ paren.push(ORD[w]+(t[i+1]==='GEN'?' Gen':'')); if(t[i+1]==='GEN')i++; continue; }
      if(RE_YEAR.test(w)){ paren.push(w); continue; }
      if(RE_CHIP.test(w)){ paren.push(w); continue; }
      if(w==='GEN'){ continue; }
      if(w==='5G'||w==='4G'||w==='XL'||w==='FE'||w==='SE'||w==='LTE'||w==='WIFI'){ out.push(w); continue; }
      if(RE_NUME.test(w)){ out.push(w.toLowerCase()); continue; }
      if(RE_NUM.test(w)){ out.push(w); continue; }
      out.push(w.charAt(0)+w.slice(1).toLowerCase());
    }
    var s=out.join(' ');
    while(s.indexOf(' +')>-1){ s=s.replace(' +','+'); }
    if(paren.length) s+=' ('+paren.join(', ')+')';
    return s;
  }
  function fmtInch(n){
    if(RE_TRI.test(n)) return n.slice(0,2)+'.'+n.slice(2)+QT;
    return n+QT;
  }
  function catOf(code){
    if(code.indexOf('IPHONE')===0) return 'iphone';
    if(code.indexOf('IPAD')===0||code.indexOf('GALAXY_TAB')===0) return 'tablet';
    if(code.indexOf('GALAXY')===0) return 'samsung';
    return 'other';
  }
  function topPrice(m){
    var best=0;
    for(var s in m){ for(var g in m[s]){ if(m[s][g]>best) best=m[s][g]; } }
    return best;
  }
  function money(n){ return 'A$'+Number(n).toLocaleString('en-AU'); }
  function norm(s){ return String(s).toLowerCase().replace(/[^a-z0-9+]/g,''); }
  function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

  function load(){
    var done=false;
    var t=setTimeout(function(){ if(!done){ done=true; snap(); } },3500);
    fetch(LIVE,{mode:'cors',cache:'no-store'})
      .then(function(r){ if(!r.ok) throw 0; return r.json(); })
      .then(function(j){ if(done)return; done=true; clearTimeout(t); ready(j,'live'); })
      .catch(function(){ if(done)return; done=true; clearTimeout(t); snap(); });
  }
  function snap(){
    fetch(SNAP,{cache:'no-store'}).then(function(r){return r.json();})
      .then(function(j){ ready(j,'snapshot'); })
      .catch(function(){ if($('qrNote')) $('qrNote').textContent='Price list unavailable - please contact us for a quote.'; });
  }
  function ready(j,src){
    DATA=j.models||j;
    LIST=Object.keys(DATA).map(function(c){
      var nm=pretty(c);
      return {code:c,name:nm,key:norm(nm),cat:catOf(c),top:topPrice(DATA[c])};
    }).sort(function(a,b){ return b.top-a.top; });
    if($('srcNote')) $('srcNote').textContent = (src==='live')
      ? 'Prices updated live from our stock system.'
      : 'Indicative prices. Final offer confirmed on inspection.';
    pickFirst();
  }

  function pool(){ return LIST.filter(function(m){ return m.cat===cat; }); }

  /* Empty query = browse the current tab. Any typed query searches ALL categories. */
  function matches(q){
    var n=norm(q);
    if(!n) return pool().slice(0,60);
    var starts=[], contains=[];
    for(var i=0;i<LIST.length;i++){
      var idx=LIST[i].key.indexOf(n);
      if(idx===0) starts.push(LIST[i]);
      else if(idx>0) contains.push(LIST[i]);
    }
    return starts.concat(contains).slice(0,60);
  }
  function renderSug(q){
    var box=$('sugBox'), list=matches(q), typed=!!norm(q);
    hi=-1;
    if(!list.length){
      box.innerHTML='<div class="sug-empty">No match for "'+esc(q)+'". Try a shorter search, e.g. "15 pro" or "fold".</div>';
      box.classList.add('open');
      return;
    }
    box.innerHTML=list.map(function(m,i){
      var tail=(typed&&m.cat!==cat)?(CATNAME[m.cat]+' - up to '+money(m.top)):('up to '+money(m.top));
      return '<div class="sug-item" data-code="'+m.code+'" data-i="'+i+'"><b>'+esc(m.name)+'</b><small>'+tail+'</small></div>';
    }).join('');
    box.classList.add('open');
  }
  function closeSug(){ $('sugBox').classList.remove('open'); }

  function syncTabs(){
    var cats=document.querySelectorAll('#devCats .dev-cat');
    for(var i=0;i<cats.length;i++){
      if(cats[i].getAttribute('data-cat')===cat) cats[i].classList.add('active');
      else cats[i].classList.remove('active');
    }
  }

  function pickFirst(){
    var p=pool();
    if(!p.length){ cur=null; $('modelInput').value=''; render(); return; }
    select(p[0].code);
  }
  function select(code){
    var m=LIST.filter(function(x){return x.code===code;})[0];
    if(!m) return;
    cur=code;
    if(m.cat!==cat){ cat=m.cat; syncTabs(); }   /* jump to the right tab automatically */
    $('modelInput').value=m.name;
    curStorage=null;
    closeSug();
    render();
  }

  function storages(){
    if(!cur||!DATA[cur]) return [];
    return Object.keys(DATA[cur]).sort(function(a,b){ return (SORD[a]||99)-(SORD[b]||99); });
  }
  function render(){
    var row=$('storageRow'), gw=$('gradesWrap');
    var st=storages();
    if(!curStorage||st.indexOf(curStorage)<0) curStorage=st[0]||null;
    row.innerHTML=st.map(function(s){
      return '<div class="opt-btn'+(s===curStorage?' active':'')+'" data-s="'+s+'">'+s+'</div>';
    }).join('') || '<div style="font-size:13px;color:var(--muted)">Select a device above.</div>';

    var prices=(cur&&curStorage&&DATA[cur][curStorage])?DATA[cur][curStorage]:{};
    if(!prices[curTier]){
      for(var i=0;i<TIERS.length;i++){ if(prices[TIERS[i].g]){ curTier=TIERS[i].g; break; } }
    }
    gw.innerHTML=TIERS.map(function(t){
      var p=prices[t.g], na=!p;
      var tag=p?((t.upto?'Up to ':'')+money(p)):'-';
      return '<div class="sg'+(na?' na':'')+((t.g===curTier&&!na)?' active':'')+'" data-g="'+t.g+'">'+
             '<div><b>'+t.name+'</b><small>'+t.desc+
             (t.note?'<br><span class="sg-note">'+t.note+'</span>':'')+'</small></div>'+
             '<span class="sgp">'+tag+'</span></div>';
    }).join('');
    quote();
  }

  /* A ticked fault either carries a fixed deduction (data-deduct, whole dollars)
     or is left for manual assessment. */
  function faults(){
    var out=[], boxes=document.querySelectorAll('#deductRow input:checked');
    for(var i=0;i<boxes.length;i++){
      var d=parseInt(boxes[i].getAttribute('data-deduct')||'0',10);
      out.push({
        label: boxes[i].getAttribute('data-fault'),
        short: boxes[i].getAttribute('data-short')||boxes[i].getAttribute('data-fault'),
        deduct: isNaN(d)?0:d
      });
    }
    return out;
  }

  function quote(){
    var prices=(cur&&curStorage&&DATA&&DATA[cur]&&DATA[cur][curStorage])?DATA[cur][curStorage]:{};
    var base=prices[curTier];
    var m=LIST.filter(function(x){return x.code===cur;})[0];
    var tier=TIERS.filter(function(t){return t.g===curTier;})[0];
    var f=faults();

    if(!base){
      $('qrVal').textContent='-';
      $('qrVal').style.fontSize='';
      $('qrNote').textContent='Select a device, storage and condition.';
      return;
    }

    var fixed=0, fixedNames=[], assessed=0;
    for(var i=0;i<f.length;i++){
      if(f[i].deduct>0){ fixed+=f[i].deduct; fixedNames.push(f[i].short+' -'+money(f[i].deduct)); }
      else assessed++;
    }
    var final=Math.max(0, base-fixed);

    /* "Up to" whenever the number can still move: Used is graded on arrival, and
       any hand-assessed fault can change the offer. */
    var ceiling = !!(tier&&tier.upto) || assessed>0;
    $('qrVal').textContent=(ceiling?'Up to ':'')+money(final);
    $('qrVal').style.fontSize=ceiling?'32px':'';

    var line=(m?m.name:'')+' - '+curStorage+' - '+(tier?tier.name:'');
    var note=line;
    if(fixedNames.length) note+=' - '+fixedNames.join(', ');
    if(assessed>0) note+=' - final offer confirmed after inspection ('+assessed+' item'+(assessed>1?'s':'')+' to assess)';
    else if(tier&&tier.note) note+=' - '+tier.note;
    $('qrNote').textContent=note;

    $('step2').classList.add('done');$('step3').classList.add('done');$('step4').classList.add('done');

    var faultLines=f.map(function(x){ return x.label+(x.deduct>0?(' (-'+money(x.deduct)+')'):' (assessed on inspection)'); });
    var msg='SELL MY PHONE QUOTE REQUEST'+NL+NL+
            'Device: '+CATNAME[cat]+' - '+(m?m.name:'')+NL+
            'Storage: '+curStorage+NL+
            'Condition: '+(tier?tier.name:'')+NL+
            'Base price: '+money(base)+NL+
            (fixed>0?('Automatic deductions: -'+money(fixed)+NL):'')+
            'Quoted price: '+(ceiling?'up to ':'')+money(final)+NL+
            (faultLines.length?('Reported issues:'+NL+'- '+faultLines.join(NL+'- ')+NL):'')+NL+
            'My preferred contact method: ';
    var base_url=(window.PE_CONTACT_URL||'/pages/contact');
    $('sellContinue').setAttribute('href',base_url+'?message='+encodeURIComponent(msg));
  }

  function boot(){
    var inp=$('modelInput');
    if(!inp) return;

    var cats=document.querySelectorAll('#devCats .dev-cat');
    for(var i=0;i<cats.length;i++){
      (function(dc){
        dc.addEventListener('click',function(){
          cat=dc.getAttribute('data-cat'); syncTabs();
          inp.value=''; pickFirst();
        });
      })(cats[i]);
    }

    /* clicking the box selects the existing text so typing replaces it */
    inp.addEventListener('focus',function(){ this.select(); renderSug(''); });
    inp.addEventListener('mouseup',function(e){ e.preventDefault(); });
    inp.addEventListener('input',function(){ renderSug(this.value); });

    $('caret').addEventListener('click',function(){
      var b=$('sugBox');
      if(b.classList.contains('open')) closeSug(); else { inp.focus(); inp.select(); renderSug(''); }
    });
    inp.addEventListener('keydown',function(e){
      var items=$('sugBox').querySelectorAll('.sug-item');
      if(e.key==='ArrowDown'||e.key==='ArrowUp'){
        e.preventDefault(); if(!items.length) return;
        hi=(e.key==='ArrowDown')?Math.min(hi+1,items.length-1):Math.max(hi-1,0);
        for(var k=0;k<items.length;k++){ items[k].classList.remove('hi'); }
        items[hi].classList.add('hi'); items[hi].scrollIntoView({block:'nearest'});
      } else if(e.key==='Enter'){
        e.preventDefault();
        if(hi>=0&&items[hi]) select(items[hi].getAttribute('data-code'));
        else if(items.length) select(items[0].getAttribute('data-code'));
      } else if(e.key==='Escape'){ closeSug(); inp.blur(); }
    });
    $('sugBox').addEventListener('mousedown',function(e){
      var it=e.target.closest('.sug-item');
      if(it){ e.preventDefault(); select(it.getAttribute('data-code')); }
    });
    document.addEventListener('click',function(e){
      if(!e.target.closest('.search-wrap')) closeSug();
    });
    $('storageRow').addEventListener('click',function(e){
      var b=e.target.closest('.opt-btn'); if(!b) return;
      curStorage=b.getAttribute('data-s'); render();
    });
    $('gradesWrap').addEventListener('click',function(e){
      var g=e.target.closest('.sg'); if(!g||g.classList.contains('na')) return;
      curTier=g.getAttribute('data-g'); render();
    });
    var dd=document.querySelectorAll('#deductRow input');
    for(var n=0;n<dd.length;n++){ dd[n].addEventListener('change',quote); }
    load();
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot);
  else boot();
})();
